import { IBuildingProviderContext } from '../../@types/ContextProviderRelated';
import { IRelation } from '../../models/Relation';
import CameraPositionSpriteModel from '../../models/standard/CameraPositionSpriteModel';
import HotspotModel from '../../models/standard/HotspotModel';
import PlanModel from '../../models/standard/PlanModel';
import SimpleMeasurementModel from '../../models/standard/SimpleMeasurementModel';
import { NonFetchableEntity } from '../planJsonExportImportUtils';
import { transformToMultiRoomBuilding } from '../transformation/tranformToMultiRoomBuilding';
import { serializeCameraPositionSprite } from './serializeCameraPositionSprite';
import { serializeHotspot } from './serializeHotspot';
import { serializeMeasurement } from './serializeMeasurement';
import { serializeNonFetchableEntities } from './serializeNonFetchableEntities';

/**
 * Export the plan as JSON.
 */
const exportPlanJson = (
  planModel: PlanModel,
  building: IBuildingProviderContext,
  measurements: SimpleMeasurementModel[],
  cameraPositionSprites: CameraPositionSpriteModel[],
  hotspots: HotspotModel[],
  nonFetchableEntities: Array<NonFetchableEntity>,
  relations?: Array<IRelation>,
): string => {
  const buildingStructure = transformToMultiRoomBuilding(building);
  const exportRelations = relations?.map((relation) => relation.toJSON()) ?? [];

  const exportObject = {
    plan: {
      name: planModel.name,
      id: planModel.id,
      kojeId: planModel.kojeId,
      kojeLevel: planModel.kojeLevel,
      eventId: planModel.eventId,
      dataObjectId: planModel.dataObjectId,
      appVersion: planModel.appVersion,
      jsonVersion: planModel.jsonVersion,
      region: planModel.region,
      annotations: [
        {
          measurements: measurements.map(serializeMeasurement),
          cameraPositionSprites: cameraPositionSprites.map(serializeCameraPositionSprite),
          hotspots: hotspots.map(serializeHotspot),
        },
      ],
      compassRotation: building.compass.rotation,
      nonFetchableEntities: nonFetchableEntities.map(serializeNonFetchableEntities),
      building: buildingStructure.toJSON(),
      relations: exportRelations,
    },
  };

  return JSON.stringify(exportObject, null, 2);
};

export default exportPlanJson;
